import { render } from "./DomainEditShowBox.vue?vue&type=template&id=6e710e6f"
import script from "./DomainEditShowBox.vue?vue&type=script&lang=js"
export * from "./DomainEditShowBox.vue?vue&type=script&lang=js"

import "./DomainEditShowBox.vue?vue&type=style&index=0&id=6e710e6f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__